
import { Tabs } from "antd";
import { useState, useRef } from "react";
import { useParams } from "react-router-dom";
import ViewAnketaPage from "./ViewAnketaPage";
import AnketaSettings from "./AnketaSettings";
import StatistikaAnketePage from "../Statistika/StatistikaAnketePage";
import "./ViewAnketaTabs.css"
import Background from "../../components/Background4";
import AnalizaInstanciPopunjavanja from "./AnalizaInstanciPopunjavanja";

const ViewAnketaTabs = () => {
  const { id } = useParams();
  const parsedAnketaId = Number(id);
  const exportRef = useRef(null);
  const [activeTab, setActiveTab] = useState("Pregled");
  const items = [
    {
      key: "Pregled",
      label: "Pregled",
      children: (
        <ViewAnketaPage anketaId={parsedAnketaId} exportRef={exportRef} />
      ), 
    },
    {
      key: "Statistika",
      label: "Statistika",
      children: <StatistikaAnketePage anketaId={parsedAnketaId} />, 
    },
     {
      key: "Odgovori",
      label: "Odgovori",
      children: <AnalizaInstanciPopunjavanja anketaId={parsedAnketaId} />, 
    },
    {
      key: "Podešavanja",
      label: "Podešavanja",
      children: (
        <AnketaSettings anketaId={parsedAnketaId} exportRef={exportRef} />
      ),
    },
  ];

  return (
    <div>
      <Background/>
    <Tabs className="anketa-tabs"
      activeKey={activeTab}
      onChange={setActiveTab}
      items={items}
      centered
    ></Tabs>
    </div>
   
  );
};
export default ViewAnketaTabs;
